module.exports = __webpack_public_path__ + "img/product_74.2c4b8ef.webp";